<template>
  <div class="trade-module">
    <van-row>
      <van-col :span="12">
        <div
          class="trade-btn left-btn"
          :class="tradetype == 0 ? 'rise' : ''"
          @click="tobuy()"
        >
          {{ $t('common.buy') }}
        </div>
      </van-col>
      <van-col :span="12">
        <div
          class="trade-btn right-btn"
          :class="tradetype == 1 ? 'fall' : ''"
          @click="tosell()"
        >
          {{ $t('common.sell') }}
        </div>
      </van-col>
      <van-col :span="24">
        <div style="font-size: 14px !important; color: #00e6ff !important;margin-top: 5px;">
          {{ $t('option.transaction') }}
        </div>
        <van-field
          readonly
          clickable
          :value="label"
          @click="showPicker = true"
          class="animated-input"
        >
          <template #right-icon>
            <van-icon name="arrow-down" />
          </template>
        </van-field>
      </van-col>
      <van-col :span="24" v-if="value == 1">
        <div class="input-border">
          <van-field
            v-model="price"
            type="number"
            center
            clearable
            :placeholder="$t('trade.price')"
            @input="inputChange"
            class="tmp animated-input"
          >
            <template #button>
              <van-button
                size="small"
                icon="plus"
                @click="btnStep(0.01)"
              ></van-button
              >&nbsp;
              <van-button
                size="small"
                icon="minus"
                @click="btnStep(-0.01)"
              ></van-button>
            </template>
          </van-field>
        </div>
        <p class="desc">&#8776; {{ parseFloat(safePrice).toFixed(2) }}</p>
      </van-col>
      <van-col :span="24" v-if="value == 2">
        <div class="input-border">
          <van-cell>{{ $t('trade.forprice') }}</van-cell>
        </div>
      </van-col>
      <van-col :span="24">
        <div class="input-border">
          <van-field
            v-model="num"
            type="number"
            center
            clearable
            @input="estimationMoney"
            :placeholder="$t('trade.num')"
            class="tmp"
          >
            <template #extra>
              {{ safeCoinname }}
            </template>
          </van-field>
        </div>
        <p class="desc">
          {{ $t('trade.used') }} {{ parseFloat(fromvalue).toFixed(8) }}
          {{ fromunit }}
        </p>
        <p class="desc" style="line-height: 1; margin-bottom: 10px">
          {{ tradetype == 0 ? $t('common.buy') : $t('common.sell') }}
          {{ parseFloat(tovalue).toFixed(8) }} {{ tounit }}
        </p>
      </van-col>
      <van-col
        :span="24 / quicknum.length"
        v-for="item in quicknum"
        :key="item"
      >
        <div class="quick-num" @click="quickMoney(item)">{{ item }}%</div>
      </van-col>
      <van-col :span="24" style="margin-top: 10px">
        <div class="input-border">
          <van-field
            v-model="money"
            type="number"
            center
            clearable
            :placeholder="$t('trade.amount')"
            @input="estimationNum"
            class="tmp"
          >
            <template #extra>
              {{ $t('common.unit') }}
            </template>
          </van-field>
        </div>
      </van-col>
      <van-col :span="24">
        <van-button
          class="trade-btn"
          :class="tradetype == 1 ? 'fall' : 'rise'"
          @click="onSubmit"
        >
          <van-loading v-if="posting" /><span v-else>
            {{ tradetype == 0 ? $t('common.buy') : $t('common.sell') }}
            {{ safeCoinname }}</span
          >
        </van-button>
      </van-col>
    </van-row>
    <van-popup v-model="showPicker" position="bottom" round>
      <van-picker
        show-toolbar
        :columns="columns"
        @confirm="onConfirm"
        value-key="label"
        :confirm-button-text="$t('common.confirm')"
        :cancel-button-text="$t('common.cancel')"
        @cancel="showPicker = false"
      />
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'TradeModules',
  props: ['coinname', 'mPrice', 'mid', 'tradetyp'],
  computed: {
    safeCoinname () {
      return this.coinname || ''
    },
    safePrice () {
      return this.mPrice || 'NaN'
    },
    safeMid () {
      return this.mid || null
    }
  },
  watch: {
    coinname (newval) {
      this.ischange = false
      if (this.tradetype == 1) {
        this.fromunit = newval
      } else {
        this.tounit = newval
      }
    },
    mPrice (newval) {
      if (!this.ischange) {
        this.price = newval
        this.toshowBalance()
      }
    },
    mid () {
      this.getMarketBalance()
    }
  },
  data () {
    return {
      tradetype: 0,
      label: null,
      columns: [
        { value: 1, label: this.$t('trade.limitprice') },
        { value: 2, label: this.$t('trade.marketprice') }
      ],
      quicknum: [25, 50, 75, 100],
      fromunit: this.$t('common.unit'),
      fromvalue: 0,
      tounit: null,
      tovalue: 0,
      usrMarketBalance: null,
      showPicker: false,
      price: null,
      num: null,
      money: null,
      value: null,
      posting: false,
      ischange: false
    }
  },
  mounted () {
    this.tounit = this.safeCoinname
    this.label = this.columns[0].label
    this.value = this.columns[0].value
  },
  methods: {
    tosell () {
      this.ischange = false
      this.tradetype = 1
      this.tounit = this.$t('common.unit')
      this.fromunit = this.safeCoinname
      this.$emit('change-trade', 1)
      this.toshowBalance()
    },
    tobuy () {
      this.ischange = false
      this.tradetype = 0
      this.fromunit = this.$t('common.unit')
      this.tounit = this.safeCoinname
      this.$emit('change-trade', 0)
      this.toshowBalance()
    },
    btnStep (val) {
      this.ischange = true
      this.price = (parseFloat(this.price) + parseFloat(val)).toFixed(8)
      this.estimationMoney()
      this.toshowBalance()
    },
    inputChange () {
      this.ischange = true
      this.estimationMoney()
    },
    toshowBalance () {
      if (this.usrMarketBalance && this.usrMarketBalance.usdt_balance) {
        if (this.tradetype == 0) {
          this.fromvalue = this.usrMarketBalance.usdt_balance
        } else {
          this.fromvalue = this.usrMarketBalance.coin_balance
        }
        let tmp_price = this.price
        if (this.value == 2) {
          tmp_price = this.safePrice
        }
        this.tovalue = (
          parseFloat(this.fromvalue) / parseFloat(tmp_price)
        ).toFixed(8)
      }
    },
    onConfirm (item) {
      this.label = item.label
      this.value = item.value
      this.showPicker = false
    },
    async getMarketBalance () {
      await this.$http({
        method: 'post',
        url: 'getMarketBalance',
        data: { m_id: this.safeMid }
      }).then(res => {
        if (res && res.data) {
          this.usrMarketBalance = res.data
          this.toshowBalance()
        }
      })
    },
    estimationMoney () {
      let tmp_price = this.price
      if (this.value == 2) {
        tmp_price = this.safePrice
      }
      if (this.num.length > 0) {
        if (this.tradetype == 0) {
          let tmpMoney = parseFloat(tmp_price) * parseFloat(this.num)
          if (parseFloat(tmpMoney) > parseFloat(this.fromvalue)) {
            this.$toast.fail(this.$t('trade.errorMoney'))
            this.money = null
          } else {
            this.money = parseFloat(tmpMoney).toFixed(8)
          }
        } else {
          if (parseFloat(this.num) > parseFloat(this.fromvalue)) {
            this.$toast.fail(this.$t('trade.errorMoney'))
            this.money = null
          } else {
            let tmpMoney = parseFloat(tmp_price) * parseFloat(this.num)
            this.money = parseFloat(tmpMoney).toFixed(8)
          }
        }
      }
    },
    estimationNum () {
      let tmp_price = this.price
      if (this.value == 2) {
        tmp_price = this.safePrice
      }
      if (this.money.length > 0) {
        let tmpvalue = this.fromvalue
        if (this.tradetype == 1) {
          tmpvalue = this.tovalue
        }

        if (parseFloat(this.money) > parseFloat(tmpvalue)) {
          this.$toast.fail(this.$t('trade.errorMoney'))
          this.num = null
        } else {
          this.num = (parseFloat(this.money) / parseFloat(tmp_price)).toFixed(8)
        }
      }
    },
    quickMoney (item) {
      this.money = (parseFloat(this.fromvalue) * parseFloat(item)) / 100
      this.estimationNum()
    },
    async onSubmit () {
      if (this.value != 2) {
        if (!(this.price && this.price.length > 0)) {
          this.$toast.fail(this.$t('trade.priceerror'))
          return
        }
      } else {
        if (!(this.money && this.money.length > 0)) {
          this.$toast.fail(this.$t('trade.moneyerror'))
          return
        }
      }
      if (!(this.num && this.num.length > 0)) {
        this.$toast.fail(this.$t('trade.numerror'))
        return
      }

      if (this.posting) {
        return
      }

      const type = this.tradetype == 0 ? 1 : 2

      const frm = {
        m_id: this.safeMid,
        num: this.num,
        price: this.price,
        operate_type: this.value,
        amount: this.money,
        type: type
      }
      this.posting = true
      await this.$http({
        method: 'post',
        url: 'upbbbuy',
        data: frm
      })
        .then(res => {
          this.posting = false
          this.$toast.success(res.msg)
          this.num = null
          this.money = null
          this.getMarketBalance()
          // 刷新页面记录列表
          if (this.value == 1) {
            this.$emit('reset-record', type)
          }
        })
        .catch(() => {
          this.posting = false
        })
    }
  }
}
</script>

<style></style>
